import axios from 'axios';
import cookieManager from '../utils/cookieManager';

axios.interceptors.request.use(
  (config) => {
    const token = cookieManager.getUserToken();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Tambah Authorization header kalau belum ada
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Pastikan ada params
    if (config.method?.toLowerCase() === 'get') {
      config.params = {
        ...config.params,
        timezone,
      };
    } else if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      // Untuk POST, PUT, PATCH
      config.data = {
        ...config.data,
        timezone,
      };
    }else if (config.data instanceof FormData) {
        config.data.append('timezone', timezone);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
